module.exports = __webpack_public_path__ + "static/media/logo-as.5ae70d6c.png";